export default __webpack_public_path__ + "images/567629fcaea6f2f13466435f8f9e7926-burger.svg";